"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const product_fruits_1 = require("product-fruits");
const base_analytics_provider_1 = require("./base-analytics-provider");
const client_sdk_common_1 = require("@easygenerator/client-sdk.common");
class ProductFruitProvider extends base_analytics_provider_1.BaseAnalyticsProvider {
    constructor(initData) {
        super();
        this.projectCode = initData.projectCode;
        this.language = initData.language || 'en';
        this.options = initData.options || {};
        client_sdk_common_1.FeatureFlagsProvider.featureFlags.on('update', this.updateValueOfIsProductFruitDisabled.bind(this));
    }
    identifyUser(identity) {
        const isProductFruitEnabled = client_sdk_common_1.FeatureFlagsProvider.featureFlags.isFeatureEnabled('product-fruits');
        if (!isProductFruitEnabled) {
            return;
        }
        if (!identity.hasOwnProperty('id')) {
            throw new Error('The input data must have an id property.');
        }
        const { id, email, firstName, lastName, fullName, phone, plan, registeredOn } = identity;
        const userObject = {
            username: id,
            email: email,
            firstname: firstName,
            lastname: lastName,
            signUpAt: registeredOn,
            props: {
                phone,
                plan,
                fullName
            }
        };
        if (!this.isInitialized) {
            try {
                product_fruits_1.productFruits.init(this.projectCode, this.language, userObject, this.options);
                this.isInitialized = true;
            }
            catch (error) {
                console.error('[analytics] Failed to initialize ProductFruits:', error);
            }
        }
        else {
            this.updateProductFruitsUserIdentity(userObject);
        }
    }
    updateUserIdentity(id, userProps) {
        if (this.isInitialized) {
            try {
                const userObject = {
                    username: id,
                    ...userProps
                };
                this.updateProductFruitsUserIdentity(userObject);
            }
            catch (error) {
                console.error('[analytics] Failed to update user identity in ProductFruits:', error);
            }
        }
    }
    updateProductFruitsUserIdentity(userObject) {
        var _a;
        try {
            if ((_a = window.productFruits) === null || _a === void 0 ? void 0 : _a.identifyUser) {
                window.productFruits.identifyUser(userObject);
            }
            else {
                product_fruits_1.productFruits.safeExec($productFruits => {
                    $productFruits.push(['updateUserData', userObject]);
                });
            }
        }
        catch (error) {
            console.error('[analytics] Failed to update user identity in ProductFruits:', error);
        }
    }
    track(eventName, properties) {
        return;
    }
    trackPage() {
        return;
    }
    performLogout() {
        var _a;
        try {
            const pf = window.productFruits;
            if ((_a = pf === null || pf === void 0 ? void 0 : pf.services) === null || _a === void 0 ? void 0 : _a.destroy) {
                pf.services.destroy();
            }
            else {
                console.warn('[analytics] ProductFruits services.destroy method not available');
            }
        }
        catch (error) {
            console.error('[analytics] Failed to logout from ProductFruits:', error);
        }
    }
    updateValueOfIsProductFruitDisabled() {
        const isProductFruitEnabled = client_sdk_common_1.FeatureFlagsProvider.featureFlags.isFeatureEnabled('product-fruits');
        if (!isProductFruitEnabled) {
            this.logout();
        }
    }
}
exports.default = ProductFruitProvider;
